function normalizeOptions(options: string[]): string[] {
  return options.map((option) => option.trim()).filter(Boolean);
}

export function parseQuestionOptions(optionsRaw?: string): string[] {
  const normalizedRaw = String(optionsRaw ?? "").trim();
  if (!normalizedRaw) return [];

  try {
    const parsed = JSON.parse(normalizedRaw);
    if (Array.isArray(parsed)) {
      const stringOptions = parsed.filter(
        (option): option is string => typeof option === "string",
      );
      return normalizeOptions(stringOptions);
    }
  } catch {
    // fallback para o formato legado CSV.
  }

  return normalizeOptions(normalizedRaw.split(","));
}

export function serializeQuestionOptions(options: string[]): string {
  const normalizedOptions = normalizeOptions(options);
  if (normalizedOptions.length === 0) return "";
  return JSON.stringify(normalizedOptions);
}
